import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  ApplicantModificationApi,
  ApplicantModificationRequest,
  ApplicantModificationSubmit,
} from '../tokens/applicant-modification.token';

/**
 * REST-only implementation of `ApplicantModificationApi` (EM-856 / EM-42).
 *
 * Calls:
 *   GET /services/embedded/api/sme-modification/for-application/{applicationId}
 *   PUT /services/embedded/api/sme-modification/{taskId}/submit
 *
 * Rule 07 / Rule 10 — no mock fallback. Playwright specs intercept via `page.route()`.
 * Authority: ROLE_SME_BORROWER (own application) or ROLE_MASTER_ADMIN (enforced server-side).
 */
@Injectable()
export class ApplicantModificationRestService implements ApplicantModificationApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/sme-modification`;

  getForApplication(applicationId: number): Observable<ApplicantModificationRequest> {
    return this.http.get<ApplicantModificationRequest>(`${this.base}/for-application/${applicationId}`);
  }

  submit(taskId: string, body: ApplicantModificationSubmit): Observable<unknown> {
    // The backend re-reads the taskId from the path, but includes it in the body too
    // (the DTO's `taskId` is @NotBlank). Send both to satisfy the contract.
    return this.http.put(`${this.base}/${taskId}/submit`, {
      taskId,
      correctedFields: body.correctedFields,
      smeComment: body.smeComment,
    });
  }
}
